export const BASE_URL = 'https://school-mate-api.uic.ubanjiaoyu.com/'
// export const BASE_URL = 'http://alumni-api.uic.lzf.com/'
// export const BASE_URL = 'https://alumniadmin.bnbu.edu.cn/'

export const URL_PATH = `${BASE_URL}`

export const HOST_URL = window.location.host

// 网络请求成功
export const HTTP_SUCCESS = 200

export const LOGIN_OUT = 10010

// token过期
export const ERROR_TOKEN = 10000

// 列表页每页请求数
export const LIST_PAGE_MAX_SIZE = 12

export const Editor_Config = {
    autoHeightEnabled: false, // 编辑器不自动被内容撑高
    initialFrameHeight: 500, // 初始容器高度
    // initialFrameWidth: '50%', // 初始容器宽度
    initialFrameWidth: 800, // 初始容器宽度
    zIndex: 0,
    serverUrl: URL_PATH + 'api/adminUpload/action',
    UEDITOR_HOME_URL: '/static/UEditor/',
}




// WEBPACK FOOTER //
// ./src/config/config.js